import { mesaEntradaTypes } from './mesaEntradaTypes';

export const cleanTramites = () => ({
  type: mesaEntradaTypes.cleanTramites,
});
export const getTramites = (data) => ({
  type: mesaEntradaTypes.getTramites,
  payload: data,
});
export const putTramites = (data) => ({
  type: mesaEntradaTypes.updateTramite,
  payload: data,
});

export const cleanDestinos = () => ({
  type: mesaEntradaTypes.cleanDestinos,
});
export const getDestinos = (data) => ({
  type: mesaEntradaTypes.getDestinos,
  payload: data,
});

export const cleanTrackingTramitesDestinos = () => ({
  type: mesaEntradaTypes.cleanTrackingTramitesDestinos,
});
export const getTrackingTramitesDestinos = (data) => ({
  type: mesaEntradaTypes.getTrackingTramitesDestinos,
  payload: data,
});
